jQuery(document).ready(
  (function($) {
    let items = [],
      page = 2,
      pageCS = 2,
      pageNews = 2;

    // $("#js--news-more").on("click", function() {
    //   if (fetchPage("posts", 3, "js-news-items", pageNews)) {
    //     fetchPage("posts", 3, "js-news-items", pageNews);
    //   } else {
    //     $("#js--news-more").remove();
    //   }
    // });

    // $( '#js--portfolio-more' ).on( 'click', function() {
    //   if( fetchPage( 'portfolio', 12, 'js-portfolio-items', page) ) {
    //     fetchPage( 'portfolio', 12, 'js-portfolio-items', page)
    //   } else {
    //     $('#js--portfolio-more').remove()
    //   }
    // } );

    //Show only 3 posts at fist and then show all after click show more
    $(".js-news-items .cell").hide();
    $(".js-news-items .cell:lt(3)").show();
    $("#js--news-more").on("click", function() {
      $(".js-news-items .cell").show();
      $("#js--news-more").hide();
    });

    $("#js--case-studies-more").on("click", function() {
      if (fetchPage("case_study", 3, "js-case-study-items", pageCS)) {
        fetchPage("case_study", 3, "js-case-study-items", pageCS);
      } else {
        $("#js--case-studies-more").remove();
      }
    });

    function fetchPage(
      postType = "portfolio",
      perPage = "12",
      appender = "js-portfolio-items",
      page,
      compare = "<"
    ) {
      let data = [],
        comparer = compare,
        fund = "",
        fund_id = "",
        url = "";

      if (postType == "portfolio") {
        fund = $(".tabs-title.is-active a").text();
        fund_id = $(".tabs-title.is-active a").attr("data-fund-id");
        url = `/wp-json/wp/v2/${postType}/?page=${page}&per_page=${perPage}&fund=${fund_id}&filter[meta_key]=sticky&filter[meta_compare]==&filter[meta_value]=1&orderby=menu_order&order=asc`;
      }

      if (postType == "case_study") {
        url = `/wp-json/wp/v2/${postType}/?page=${page}&per_page=${perPage}`;
      }

      // if (postType == "posts") {
      //   url = `/wp-json/wp/v2/${postType}/?page=${page}&per_page=${perPage}`;
      // }

      //console.log(url);
      $.getJSON(url, function(data) {
        let items = [];
        $.each(data, function(key, item) {
          //console.log(item);
          const html = buildHTML(item, postType);
          items.push(html);
          //console.log(html);
          $(`.${appender}`).append(items);
          items = [];
        });
      }).done(() => {
        Foundation.reInit("equalizer");
        page++;
      });
    }

    function buildHTML(item, postType) {
      let html = "";

      if (postType == "portfolio") {
        //remove acf added <p> tags from field
        let summary = item.acf.summary.slice(3, -5);
        let fund = $(".tabs-title.is-active a").text();
        let amount = 0;
        if (item.acf.amount)
          amount = item.acf.amount
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let city = "";
        if (item.acf.geography.city) {
          city = item.acf.geography.city;
        } else {
          let addr = item.acf.geography.address;
          addr = addr.split(",");
          city = addr[0];
        }

        html = `
            <div class="cell">
              <div class="card card--portfolio">
                <div data-equalizer-watch class="card__top--portfolio">
                  <div class="featured-portfolio-item__image-side">
                  `;
        if (item.acf.logo_1) {
          html += `
                    <img src="${item.acf.logo_1.url}" class="featured-portfolio-item__image">
                  `;
        }
        if (item.acf.logo_2) {
          html += `
                    <img src="${item.acf.logo_2.url}" class="featured-portfolio-item__image">
                  `;
        }

        html += `
                  </div>
                  <div class="featured-portfolio-item__content">
                    <p class="featured-portfolio-item__date">${item.acf.year}</p>
                    <h4 class="featured-portfolio-item__title">${item.title.rendered}</h4>
                    <a data-id="dropdown-${item.id}" class="js--portfolio-read-more featured-portfolio-item__link">+ read more</a>
                  </div>
                </div>
      `;

        html += `
                <div class="js--portfolio-content card__bottom--portfolio" id="dropdown-${item.id}">
                        <p class="featured-portfolio-item__stat featured-portfolio-item__stat--summary">${summary}</p>
                        <p class="featured-portfolio-item__stat featured-portfolio-item__stat--fund">Fund:<br><strong>${fund}</strong></p>
                        <p class="featured-portfolio-item__stat featured-portfolio-item__stat--sector">Sector:<br><strong>${item.acf.sector}</strong></p>
                        <div class="featured-portfolio-item__stat featured-portfolio-item__stat--grp">
                            <p class="featured-portfolio-item__stat--geography">Geography:<br><strong>${city}, ${item.acf.geography.state_short}</strong></p>
      `;
        if (amount != "0" && amount != "$0")
          html += `
                            <p class="featured-portfolio-item__stat--amount">Amount:<br><strong>$${amount}</strong></p>
        `;

        html += `
                        </div>
                </div>
              </div>
            </div>
      `;
      }

      if (postType == "case_study") {
        html = `
                <div class="cell">
                  <div data-equalizer-watch  class="card card--case-study">
                    <div class="card-section card-section--case-study">
                      <div class="case-study-item__image">
                        <img src="${item.fimg_url}" class="case-study-item__image">
                      </div>
                      <div class="case-study-item__content">
                        <div class="case-study-item__fund-wrap">
                          <img class="m-r-1" src="../wp-content/themes/seachange/assets/images/svg/folder.svg" />
                          <span class="case-study-item__fund">${item.acf.fund}</span>
                        </div>
                        <h4 class="case-study-item__title">${item.title.rendered}</h4>
                        <p class="case-study-item__excerpt">${item.acf.summary}</p>
                        <a href="${item.link}" class="case-study-item__link">+ read more</a>
                      </div>
                    </div>
                  </div>
                </div>
                      `;
      }

      if (postType == "posts") {
        let imageURL = item.fimg_url;
        let extraClass = "";

        if (!imageURL) {
          imageURL = "/wp-content/themes/seachange/assets/images/logo.png";
          extraClass = "news-item__image--fallback";
        }
        html = `
        <div class="cell medium-3">
                  <div data-equalizer-watch  class="card card--news">
                    <div class="card-section card-section--news">
                      <div class="news-item__image">
                          <img src="${imageURL}" class="news-item__image ${extraClass}">
                      </div>
                      <div class="news-item__content">
                        <h6 class="news-item__date"><img class="news-item__date-icon" src="../wp-content/themes/seachange/assets/images/svg/calendar.svg" width="14" height="14" />${item.pdate}</h4>
                        <h4 class="news-item__title">${item.title.rendered}</h4>
                      </div>
                        <a href="${item.link}" class="news-item__link">+ read article</a>
                    </div>
                  </div>
                </div>                      `;
      }

      return html;
    }
  })(jQuery)
);
